import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";
import moment from "moment";
import { saveAs } from "file-saver";

const BrazilHybridMaizeReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/researchProgramMIS");
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getCropCutData } = useHttp();

  const fillCropCutData = async (
    employeeId,
    regionId,
    // farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    // if (farmerNo != "") {
    //   urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    // }

    // if (getType != "") {
    //   urlfilter = urlfilter + `&getType=${getType}`;
    // }

    // if (
    //   stateName &&
    //   typeof stateName === "string" &&
    //   stateName.trim().length > 0
    // ) {
    //   const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
    //   urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    // }

    var url = `/api/brazilHybridMaizeReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getCropCutData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        if (getType == "Excel") {
          console.log("reportdata", data);
          // const handleDownload = async () => {
          //   const blob = await data.blob();
          //   const url = window.URL.createObjectURL(blob);
          //   const link = document.createElement('a');
          //   link.href = url;
          //   link.download = 'downloaded-file.csv'; // Set the file name here
          //   link.click();
          // }
        } else {
          console.log("reportdata", data);
          setData(data);
        }
      }
    );
  };

  const excelDownload = async (
    employeeId,
    regionId,
    // farmerNo,
    getType = "Excel"
  ) => {
    setLoading(true);
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `${
      process.env.REACT_APP_BASE_URL
    }/api/brazilHybridMaizeReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "brazilHybridMaizeReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    fillCropCutData(0, 0, "");
  }, [getCropCutData]);

  const customHeaders = [
    [
      { label: "Location", rowSpan: 2 },
      { label: "Country", rowSpan: 2 },
      { label: "Season", rowSpan: 2 },
      { label: "Planting Date", rowSpan: 2 },
      { label: "Harvest Date", rowSpan: 2 },
      { label: "Altitude", rowSpan: 2 },
      { label: "Latitude", rowSpan: 2 },
      { label: "Longitude", rowSpan: 2 },
      { label: "PLOT", rowSpan: 2 },
      { label: "ENTRY", rowSpan: 2 },
      { label: "GENOTYPE", rowSpan: 2 },
      { label: "Plant Stand", rowSpan: 2 },
      { label: "Days", colSpan: 2 },
      { label: "Height", colSpan: 2 },
      { label: "Plant Aspect", rowSpan: 2 },
      { label: "Husk Cover", rowSpan: 2 },
      { label: "Lodging", colSpan: 2 },
      { label: "Plants Harv.", rowSpan: 2 },
      { label: "Ears Harv.", rowSpan: 2 },
      { label: "Ears/plant", rowSpan: 2 },
      { label: "Ear Aspect", rowSpan: 2 },
      { label: "Field Wt", rowSpan: 2 },
      { label: "Grain Moist", rowSpan: 2 },
      { label: "GRAIN YLD", rowSpan: 2 },
      { label: "MSV", rowSpan: 2 },
      { label: "Rust", rowSpan: 2 },
      { label: "L. Blight", rowSpan: 2 },
      { label: "Curv", rowSpan: 2 },
    ],
    ["Pollen", "Silk", "Plant", "Ear", "Root", "Stem"],
  ];

  const fieldsToExport = [
    "location",
    "country",
    "seasonName",
    "plantingDate",
    "harvestDate",
    "altitude",
    "latitude",
    "longitude",
    "plot",
    "entry",
    "genoType",
    "plantStand",
    "daysPollen",
    "daysSilk",
    "heightPlant",
    "heightsEar",
    "aspect",
    "huskCover",
    "lodgingRoot",
    "lodgingStem",
    "plantsHarv",
    "earsHarv",
    "earsPerPlant",
    "earAspect",
    "fieldWt",
    "grainMoist",
    "grainYld",
    "msv",
    "rust",
    "lblight",
    "curv",
  ];

  const convertToExcel = (data, fieldsToExport, filename, customHeaders) => {
    const wb = XLSX.utils.book_new();
    const wsData = [];

    const topRow = [];
    const subRow = [];

    const topHeaders = customHeaders[0];
    const subHeaders = customHeaders[1];

    topHeaders.forEach((col) => {
      topRow.push(col.label);
      if (col.colSpan && col.colSpan > 1) {
        for (let i = 1; i < col.colSpan; i++) {
          topRow.push(""); // filler for merged cells
        }
      }
      if (col.rowSpan && col.rowSpan === 2) {
        subRow.push(""); // filler since it spans two rows
        if (col.colSpan && col.colSpan > 1) {
          for (let i = 1; i < col.colSpan; i++) {
            subRow.push(""); // filler
          }
        }
      } else if (col.colSpan && col.colSpan > 1) {
        subRow.push(...subHeaders.splice(0, col.colSpan));
      }
    });

    wsData.push(topRow);
    wsData.push(subRow);

    // Add data rows
    data.forEach((item) => {
      const row = fieldsToExport.map((field) => item[field]);
      wsData.push(row);
    });

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Merge headers
    const merges = [];
    let col = 0;
    topHeaders.forEach((colDef) => {
      const colSpan = colDef.colSpan || 1;
      const rowSpan = colDef.rowSpan || 1;

      const start = XLSX.utils.encode_cell({ r: 0, c: col });
      const end = XLSX.utils.encode_cell({
        r: rowSpan - 1,
        c: col + colSpan - 1,
      });

      if (start !== end) {
        merges.push({
          s: { r: 0, c: col },
          e: { r: rowSpan - 1, c: col + colSpan - 1 },
        });
      }

      col += colSpan;
    });

    ws["!merges"] = merges;
    ws["!cols"] = fieldsToExport.map(() => ({ wch: 15 }));

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);
  };

  const handleExportExcel = () => {
    const filename = "brazilHybridMaizeReport.xlsx";


    convertToExcel( data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Brazil Hybrid Maize Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row align-items-end">
              {/* Procurement Officer */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="executive_officer">Agronomy Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      const userid =
                        e.target.value !== "--Select--" ? e.target.value : 0;
                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Apply Date Filter Dropdown */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="date_filter">Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {/* From and To Dates (conditional) */}
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        id="from_date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        id="to_date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Submit Button */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillCropCutData(employeeId, regionId, null);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>

            <h5>Please select the parameters to get the desired result</h5>
            <hr />
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>

              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, regionId, farmerNumber, "Excel");
                }}
                disabled={loading}
              > */}
              {/* {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )} */}
              {/* </button> */}
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th rowSpan="2">Location</th>
                          <th rowSpan="2">Country</th>
                          <th rowSpan="2">Season</th>
                          <th rowSpan="2">Planting Date</th>
                          <th rowSpan="2">Harvest Date</th>
                          <th rowSpan="2">Altitude</th>
                          <th rowSpan="2">Latitude</th>
                          <th rowSpan="2">Longitude</th>
                          <th rowSpan="2">PLOT</th>
                          <th rowSpan="2">ENTRY</th>
                          <th rowSpan="2">GENOTYPE</th>
                          <th colSpan="1">
                            Plant
                            <br />
                            Stand
                          </th>
                          <th colSpan="2">Days</th>
                          <th colSpan="2">Height</th>
                          <th colSpan="1">
                            Plant
                            <br />
                            Aspect
                          </th>
                          <th colSpan="1">
                            Husk
                            <br />
                            Cover
                          </th>
                          <th colSpan="2">Lodging</th>
                          <th colSpan="1">Plants Harv.</th>
                          <th colSpan="1">Ears Harv.</th>
                          <th colSpan="1">Ears/plant</th>
                          <th colSpan="1">
                            Ear
                            <br />
                            Aspect
                          </th>
                          <th colSpan="1">
                            Field
                            <br />
                            Wt
                          </th>
                          <th colSpan="1">
                            Grain
                            <br />
                            Moist
                          </th>
                          <th colSpan="1">
                            GRAIN
                            <br />
                            YLD
                          </th>
                          <th rowSpan="2">MSV</th>
                          <th rowSpan="2">Rust</th>
                          <th rowSpan="2">L. Blight</th>
                          <th rowSpan="2">Curv</th>
                        </tr>
                        <tr className="table-header">
                          <th></th> {/* Plant Stand already included above */}
                          <th>Pollen</th>
                          <th>Silk</th>
                          <th>Plant</th>
                          <th>Ear</th>
                          <th></th> {/* Plant Aspect already included above */}
                          <th></th> {/* Husk Cover already included above */}
                          <th>Root</th>
                          <th>Stem</th>
                          <th></th> {/* Plants Harv. already included above */}
                          <th>Harv.</th>
                          <th></th> {/* Ears/plant already included above */}
                          <th></th> {/* Ear Aspect already included above */}
                          <th></th> {/* Field Wt already included above */}
                          <th></th> {/* Grain Moist already included above */}
                          <th></th> {/* GRAIN YLD already included above */}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              {/* <td>{i + 1}</td> */}
                              <td>{itm.location}</td>
                              <td>{itm.country}</td>
                              <td>{itm.seasonName}</td>
                              <td>{itm.plantingDate}</td>
                              <td>{itm.harvestDate}</td>
                              <td>{itm.altitude}</td>
                              <td>{itm.latitude}</td>
                              <td>{itm.longitude}</td>
                              <td>{itm.plot}</td>
                              <td>{itm.entry}</td>
                              <td>{itm.genoType}</td>
                              <td>{itm.plantStand}</td>
                              <td>{itm.daysPollen}</td>
                              <td>{itm.daysSilk}</td>
                              <td>{itm.heightPlant}</td>
                              <td>{itm.heightsEar}</td>
                              <td>{itm.aspect}</td>
                              <td>{itm.huskCover}</td>
                              <td>{itm.lodgingRoot}</td>
                              <td>{itm.lodgingStem}</td>
                              <td>{itm.plantsHarv}</td>
                              <td>{itm.earsHarv}</td>
                              <td>{itm.earsPerPlant}</td>
                              <td>{itm.earAspect}</td>
                              <td>{itm.fieldWt}</td>
                              <td>{itm.grainMoist}</td>
                              <td>{itm.grainYld}</td>
                              <td>{itm.msv}</td>
                              <td>{itm.rust}</td>
                              <td>{itm.lblight}</td>
                              <td>{itm.curv}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BrazilHybridMaizeReport;
